import { useQuery } from '@tanstack/react-query';
import { customerService } from '../../../services/api';

const STALE_TIME_BUFFER_MS = 5_000;

export const useMessageMediaAccessQuery = (messageUuid, enabled = true) => {
  return useQuery({
    queryKey: ['message-media-access', messageUuid],
    queryFn: () => customerService.getMessageMediaAccess(messageUuid).then((res) => res.data),
    enabled: enabled && Boolean(messageUuid),
    staleTime: (query) => {
      const expiresIn = query.state.data?.expires_in;

      if (!expiresIn) {
        return 0;
      }

      return Math.max((expiresIn * 1000) - STALE_TIME_BUFFER_MS, 0);
    },
  });
};
